import axios from "axios";
import { API_URLS, api } from "../../config";

function createRealtimeSessionApi(payload) {
  return axios.post(API_URLS.REALTIME.SESSION, payload);
}

function getRealtimeStagesApi(language = "en") {
  return axios.get(API_URLS.REALTIME.STAGES, {
    params: { language },
  });
}

function getChatDescriptionByChatIdApi(chatId) {
  return api.get(API_URLS.CHAT.GET_DESCRIPTION_BY_CHAT_ID, {
    params: { chatId },
  });
}

export {
  createRealtimeSessionApi,
  getRealtimeStagesApi,
  getChatDescriptionByChatIdApi,
};
